import React from 'react';

import { ContentText } from './styles';

const BodyMesclarNestle = () => {
  return (
    <ContentText>
      Não é permitido realizar parametrização mesclando os grupos contratante
      Nestlé com outras contratantes!
    </ContentText>
  );
};

export default { BodyMesclarNestle };
